<template lang='pug'>
  div(ref='charts', :style='style')
</template>

<script>
import echarts from 'echarts';
import theme from './theme';

export default {
  props: {
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    option: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height,
      };
    }
  },
  watch: {
    option: {
      deep: true,
      handler() {
        this.myChart.clear();
        this.myChart.setOption(this.option);
      }
    }
  },
  async mounted() {
    echarts.registerTheme('walden', theme);
    this.myChart = echarts.init(this.$refs.charts, 'walden');
    if (this.option) this.myChart.setOption(this.option);
    this.$emit('created', this.myChart);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/v-charts/index.vue?4b7810b6